import React, { useState } from "react";

const ItemsForm = ({
  items,
  item,
  handleItemChange,
  addItem,
  removeItem,
  updateItem,
  isDetailedForm,
  setIsDetailedForm,
  isSpecialForm,
  setIsSpecialForm,
  numberOfSpecialPages,
  setNumberOfSpecialPages,
  itemErrors = {},
  itemsError = "",
}) => {
  const [editingIndex, setEditingIndex] = useState(null);

  const inputClass = (field, extra = "") =>
    `px-3 py-2 border rounded text-sm bg-white dark:bg-gray-800 text-gray-800 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 focus:ring-2 focus:outline-none transition ${
      itemErrors[field]
        ? "border-red-500 dark:border-red-400 focus:ring-red-400"
        : "border-gray-300 dark:border-gray-700 focus:ring-indigo-400"
    } ${extra}`;

  const hasItemInputErrors = Object.keys(itemErrors).length > 0;

  const startEditing = (index) => {
    setEditingIndex(index);
    const itm = items[index];
    handleItemChange("description", itm.description);
    handleItemChange("unit", itm.unit);
    handleItemChange("unitPrice", itm.unitPrice);
  };

  const saveEdit = () => {
    if (editingIndex !== null) {
      updateItem(editingIndex, item);
      setEditingIndex(null);
      handleItemChange("description", "");
      handleItemChange("unit", 1);
      handleItemChange("unitPrice", "");
    }
  };

  return (
    <div className="transition-colors duration-300 text-gray-800 dark:text-gray-200">
      <h2 className="text-lg font-semibold mb-4">Description</h2>
      {itemsError && (
        <p className="mb-3 rounded-md border border-red-300 dark:border-red-700 bg-red-50 dark:bg-red-900/20 px-3 py-2 text-sm font-medium text-red-600 dark:text-red-300">
          {itemsError}
        </p>
      )}

      {/* ✅ ปุ่มเลือกประเภทฟอร์ม */}
      <div className="mb-4 flex flex-wrap items-center gap-4 text-sm text-gray-700 dark:text-gray-300">
        <label className="flex items-center gap-2">
          <input
            type="radio"
            name="formType"
            checked={!isDetailedForm && !isSpecialForm}
            onChange={() => {
              setIsDetailedForm(false);
              setIsSpecialForm(false);
            }}
          />
          <span>Standard Form (MAX 10 per page)</span>
        </label>

        <label className="flex items-center gap-2">
          <input
            type="radio"
            name="formType"
            checked={isDetailedForm && !isSpecialForm}
            onChange={() => {
              setIsDetailedForm(true);
              setIsSpecialForm(false);
            }}
          />
          <span>Detailed Form (MAX 4 per page)</span>
        </label>

        <label className="flex items-center gap-2">
          <input
            type="radio"
            name="formType"
            checked={isSpecialForm}
            onChange={() => {
              setIsSpecialForm(true);
              setIsDetailedForm(false);
            }}
          />
          <span>Special Form (Auto Split Page Description)</span>
        </label>
      </div>
     {/* ✅ ช่องจำนวนหน้า เฉพาะ Special Form */}
      {/* {isSpecialForm && (
        <div className="mb-4">
          <label className="block text-gray-600 text-sm mb-1">จำนวนหน้า:</label>
          <input
            type="number"
            min={1}
            value={numberOfSpecialPages}
            onChange={(e) =>
              setNumberOfSpecialPages(Number(e.target.value) || 1)
            }
            className="border rounded px-2 py-1 w-32"
          />
        </div>
      )} */}
      {/* ✅ ตารางรายการ */}
      {items.length > 0 && (
        <div className="mb-4 overflow-x-auto">
          <table className="w-full table-fixed border border-gray-200 dark:border-gray-700 rounded-lg text-sm transition-colors duration-300">
            <thead className="bg-gray-50 dark:bg-gray-800 text-gray-600 dark:text-gray-300">
              <tr>
                <th className="px-3 py-2 text-left w-2/5">Description</th>
                <th className="px-3 py-2 text-right w-1/6">Units</th>
                <th className="px-3 py-2 text-right w-1/6">Unit Price (THB)</th>
                <th className="px-3 py-2 text-right w-1/6">Amount (THB)</th>
                <th className="px-3 py-2 text-center w-1/6">Action</th>
              </tr>
            </thead>
            <tbody>
              {items.map((itm, index) => (
                <tr
                  key={index}
                  className={`${
                    index % 2 === 0
                      ? "bg-white dark:bg-gray-900"
                      : "bg-gray-50 dark:bg-gray-800"
                  } hover:bg-gray-100 dark:hover:bg-gray-700 transition`}
                >
                  <td className="px-3 py-2 whitespace-pre-line break-words max-w-xs">
                    {itm.description}
                  </td>
                  <td className="px-3 py-2 text-right">{itm.unit}</td>
                  <td className="px-3 py-2 text-right">
                    {parseFloat(itm.unitPrice).toLocaleString("th-TH")}
                  </td>
                  <td className="px-3 py-2 text-right">
                    {(itm.unit * itm.unitPrice).toLocaleString("th-TH")}
                  </td>
                  <td className="px-3 py-2 text-center">
                    <div className="flex justify-center gap-2">
                      <button
                        type="button"
                        onClick={() => startEditing(index)}
                        className="px-2 py-1 rounded bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300 hover:bg-blue-200 dark:hover:bg-blue-800/70 text-xs transition"
                      >
                        Edit
                      </button>
                      <button
                        type="button"
                        onClick={() => removeItem(index)}
                        className="px-2 py-1 rounded bg-red-100 dark:bg-red-900/40 text-red-700 dark:text-red-300 hover:bg-red-200 dark:hover:bg-red-800/70 text-xs transition"
                      >
                        Remove
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* ✅ ฟอร์มเพิ่ม/แก้ไข Item */}
      <div className="flex flex-col md:flex-row gap-3">
        <textarea
          name="description"
          placeholder="Item Description"
          value={item.description}
          onChange={(e) => handleItemChange("description", e.target.value)}
          rows={3}
          className={inputClass("description", "w-full resize-y")}
        />
        <input
          type="number"
          name="unit"
          placeholder="Units"
          value={item.unit}
          onChange={(e) => handleItemChange("unit", e.target.value)}
          className={inputClass("unit", "w-24")}
        />
        <input
          type="number"
          name="unitPrice"
          placeholder="Unit Price"
          value={item.unitPrice}
          onChange={(e) => handleItemChange("unitPrice", e.target.value)}
          className={inputClass("unitPrice", "w-32")}
        />
        {editingIndex !== null ? (
          <button
            type="button"
            onClick={saveEdit}
            className="px-4 py-2 rounded bg-green-100 dark:bg-green-900/40 text-green-700 dark:text-green-300 hover:bg-green-200 dark:hover:bg-green-800/70 text-sm transition"
          >
            Save
          </button>
        ) : (
          <button
            type="button"
            onClick={addItem}
            className="px-4 py-2 rounded bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300 hover:bg-blue-200 dark:hover:bg-blue-800/70 text-sm transition"
          >
            Add
          </button>
        )}
      </div>
      {hasItemInputErrors && (
        <div className="mt-2 grid grid-cols-1 gap-1 text-xs font-medium text-red-500 dark:text-red-400 md:grid-cols-[1fr_6rem_8rem_auto] md:gap-3">
          <p>{itemErrors.description || ""}</p>
          <p>{itemErrors.unit || ""}</p>
          <p>{itemErrors.unitPrice || ""}</p>
          <span />
        </div>
      )}
    </div>
  );
};

export default ItemsForm;
